<template>
  <div
    class="credit-pack-purchase-footer flex items-center justify-between w-full"
  >
    <div>
      <p
        class="text-neutral-text-weak mb-4"
        data-testid="credit-pack-footer-text"
      >
        Add credit packs to increase your annual balance
      </p>
      <LearnMoreLink
        text="Learn how credits work"
        url="https://help.crossbeam.com/en/articles/15588582-crossbeam-credits-faq"
        event-site="credit_usage_summary_card"
      />
    </div>
    <BittsButton
      type="primary"
      size="small"
      text="Add more credits"
      data-testid="credit-pack-add-more-credits"
      @click="router.push('/billing/add-credits')"
    />
  </div>
</template>

<script setup lang="ts">
import { BittsButton } from '@crossbeam/bitts';

import { useRouter } from 'vue-router';

import LearnMoreLink from '@/components/LearnMoreLink.vue';

const router = useRouter();
</script>
